import Dosage from '@/fhirworks/types/Dosage';
import MedicationX from '@/fhirworks/types/MedicationX';
import Period from '@/fhirworks/types/Period';
import ReportedX from '@/fhirworks/types/ReportedX';
import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import DuplicateReview from './DuplicateReview';
import Reconciliation from './Reconciliation';
import ScriptSureWebhookLog from './ScriptSureWebhookLog';
import CodeableConcept from './types/CodeableConcept';
import Coding from './types/Coding';
import Reference from './types/Reference';

export default class MedicationRequest extends DomainResource {
    static __className = 'MedicationRequest';

    __objectStructure = {
        status: String, // active | on-hold | cancelled | completed | entered-in-error | stopped | draft | unknown
        statusReason: CodeableConcept,
        statusChanged: String, // dateTime; R5 MedicationRequest.statusChanged, backported as an extension
        intent: String, // proposal | plan | order | original-order | reflex-order | filler-order | instance-order | option
        category: [CodeableConcept],
        reported: ReportedX,
        medication: MedicationX,
        subject: Reference,
        encounter: Reference,
        supportingInformation: [Reference],
        authoredOn: String,
        requester: Reference,
        performer: Reference,
        performerType: CodeableConcept,
        recorder: Reference,
        dosageInstruction: [Dosage],
        reasonCode: [CodeableConcept],
        priorPrescription: Reference,

        // first class extensions
        effective: Period,
        isMedicationEffective: Coding,
        takenAsDirected: Coding,
        scriptSurePrescriptionId: String,
        scriptSureEncounterId: String,
        reconciliation: [Reconciliation],
        duplicateReview: [DuplicateReview], // Keep both: one per other entry, against the drug it was confirmed for.
        includeInTreatmentPlan: Boolean,
        scriptSureWebhookLog: [ScriptSureWebhookLog],
        updatedBy: Reference,
        ncpdpPrescriberOrderNumber: String,
        ncpdpStatus: String,
        taperNotes: String,
        administrationType: String, // scheduled | taper | prn. The clinician's choice, stored rather than re-derived from the chain.
        administeringLocation: Reference, // the window these doses are given at. Resolved at read time when absent - never written by default.
        addedFromPreset: Reference, // the BN_MedicationPreset this entry was applied from, with its name at the time as display
    };

    constructor(constructJson, className = 'MedicationRequest') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
